var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.004,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.708 11.005L25.563 18.54l1.876-4.446 8.269-3.09z",
    fill: "#E2761B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.285 11.004L22.35 18.61l-1.785-4.517-8.279-3.09zM32.057 28.47l-2.702 4.14 5.782 1.59 1.662-5.639-4.742-.091zm-20.842.091l1.652 5.639 5.78-1.59-2.701-4.14-4.731.091z",
    fill: "#E4761B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.322 21.476l-1.611 2.437 5.74.255-.204-6.169-3.925 3.477zm11.35 0l-3.977-3.548-.133 6.24 5.73-.255-1.62-2.437zM18.648 32.61l3.447-1.683-2.977-2.325-.47 4.008zm7.25-1.683l3.457 1.683-.48-4.008-2.977 2.325z",
    fill: "#E4761B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.355 32.61l-3.457-1.682.276 2.253-.03.948 3.211-1.519zm-10.707 0l3.212 1.52-.02-.949.255-2.253-3.447 1.682z",
    fill: "#D7C1B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.91 27.115l-2.875-.846 2.03-.928.845 1.774zm4.172 0l.846-1.774 2.04.928-2.886.846z",
    fill: "#233447"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.647 32.61l.49-4.14-3.192.093 2.702 4.047zm10.216-4.14l.49 4.14 2.702-4.047-3.192-.092zm2.426-4.557l-5.73.255.53 2.947.846-1.774 2.04.927 2.314-2.355zm-12.253 2.355l2.039-.927.836 1.774.54-2.947-5.74-.255 2.325 2.355z",
    fill: "#CD6116"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 23.914l2.407 4.69-.081-2.335-2.325-2.355zm12.267 2.354l-.102 2.335 2.416-4.69-2.314 2.355zm-6.527-2.1l-.54 2.947.673 3.477.153-4.578-.285-1.846zm3.11 0l-.275 1.835.122 4.589.684-3.477-.53-2.947z",
    fill: "#E4751F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.093 27.114l-.683 3.477.49.336 2.977-2.325.102-2.334-2.886.846zm-7.058-.846l.082 2.334 2.977 2.325.49-.336-.674-3.477-2.875-.846z",
    fill: "#F6851B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.143 34.13l.03-.949-.255-.224h-3.844l-.234.224.02.949-3.212-1.52 1.122.918 2.274 1.58h3.905l2.284-1.58 1.122-.918-3.212 1.52z",
    fill: "#C0AD9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.898 30.928l-.49-.336h-2.824l-.49.336-.254 2.254.234-.225h3.844l.255.225-.275-2.254z",
    fill: "#161616"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.132 19.028l.866-4.16-1.295-3.864-9.809 7.28 3.773 3.191L35 23.035l1.182-1.376-.51-.367.816-.744-.632-.49.816-.622-.54-.408zM11 14.868l.867 4.16-.55.408.815.622-.622.49.816.744-.51.367 1.172 1.377 5.333-1.56 3.772-3.192-9.808-7.28L11 14.868z",
    fill: "#763D16"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.003 23.036l-5.333-1.56 1.621 2.437-2.416 4.69 3.181-.041h4.742l-1.795-5.526zm-16.681-1.56l-5.333 1.56-1.774 5.526h4.73l3.172.04-2.406-4.69 1.61-2.436zm7.237 2.693l.336-5.884 1.55-4.19h-6.883l1.53 4.19.357 5.884.122 1.855.01 4.568h2.825l.02-4.568.133-1.855z",
    fill: "#F6851B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.00033b0635401e9a6467e9390f63f151.svg";
export { ForwardRef as ReactComponent };